var O = Object.defineProperty;
var F = (o, r, t) => r in o ? O(o, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[r] = t;
var c = (o, r, t) => F(o, typeof r != "symbol" ? r + "" : r, t);
import { inject as h, shallowRef as m, markRaw as y, defineComponent as g, provide as l, createVNode as w, Teleport as C, ref as A, getCurrentInstance as D, onBeforeMount as R, onUnmounted as W, Fragment as j, h as S } from "vue";
import { CoreMarkView as U, CoreNodeView as E, CorePluginView as K, CoreWidgetView as T } from "@prosemirror-adapter/core";
import { nanoid as x } from "nanoid";
import { Decoration as H } from "prosemirror-view";
const P = Symbol("[ProsemirrorAdapter]markViewContext"), te = () => h(P), f = Symbol("[ProsemirrorAdapter]useMarkViewFactory"), re = () => h(f);
class L extends U {
  constructor() {
    super(...arguments);
    c(this, "key", x());
    c(this, "context", {
      contentRef: (t) => {
        t && t instanceof HTMLElement && this.contentDOM && t.firstChild !== this.contentDOM && t.appendChild(this.contentDOM);
      },
      view: this.view,
      mark: m(this.mark)
    });
    c(this, "updateContext", () => {
      Object.entries({
        mark: this.mark
      }).forEach(([t, e]) => {
        const n = this.context[t];
        n.value !== e && (n.value = e);
      });
    });
    c(this, "render", () => {
      const t = this.component;
      return y(/* @__PURE__ */ g({
        name: "ProsemirrorMarkView",
        setup: () => (l(P, this.context), () => w(C, {
          key: this.key,
          to: this.dom
        }, {
          default: () => [w(t, null, null)]
        }))
      }));
    });
  }
}
const p = Symbol("[ProsemirrorAdapter]nodeViewContext"), ne = () => h(p), v = Symbol("[ProsemirrorAdapter]useNodeViewFactory"), oe = () => h(v);
class B extends E {
  constructor() {
    super(...arguments);
    c(this, "key", x());
    c(this, "context", {
      contentRef: (t) => {
        t && t instanceof HTMLElement && this.contentDOM && t.firstChild !== this.contentDOM && t.appendChild(this.contentDOM);
      },
      view: this.view,
      getPos: this.getPos,
      setAttrs: this.setAttrs,
      node: m(this.node),
      selected: m(this.selected),
      decorations: m(this.decorations),
      innerDecorations: m(this.innerDecorations)
    });
    c(this, "updateContext", () => {
      Object.entries({
        node: this.node,
        selected: this.selected,
        decorations: this.decorations,
        innerDecorations: this.innerDecorations
      }).forEach(([t, e]) => {
        const n = this.context[t];
        n.value !== e && (n.value = e);
      });
    });
    c(this, "render", () => {
      const t = this.component;
      return y(/* @__PURE__ */ g({
        name: "ProsemirrorNodeView",
        setup: () => (l(p, this.context), () => w(C, {
          key: this.key,
          to: this.dom
        }, {
          default: () => [w(t, null, null)]
        }))
      }));
    });
  }
}
const k = Symbol("[ProsemirrorAdapter]nodeViewContext"), ie = () => h(k), M = Symbol("[ProsemirrorAdapter]usePluginViewFactory"), se = () => h(M);
class I extends K {
  constructor() {
    super(...arguments);
    c(this, "key", x());
    c(this, "context", {
      view: m(this.view),
      prevState: m(this.prevState)
    });
    c(this, "updateContext", () => {
      Object.entries({
        view: this.view,
        prevState: this.prevState
      }).forEach(([t, e]) => {
        const n = this.context[t];
        if (t === "view") {
          const i = Object.assign(Object.create(Object.getPrototypeOf(e)), e);
          n.value = i;
          return;
        }
        n.value = e;
      });
    });
    c(this, "render", () => {
      const t = this.component;
      return y(/* @__PURE__ */ g({
        name: "ProsemirrorNodeView",
        setup: () => (l(k, this.context), () => w(C, {
          key: this.key,
          to: this.root
        }, {
          default: () => [w(t, null, null)]
        }))
      }));
    });
  }
}
function _(o, r) {
  return (e) => (n, i, s) => {
    const V = new L({
      mark: n,
      view: i,
      inline: s,
      options: {
        ...e,
        destroy() {
          var a;
          (a = e.destroy) == null || a.call(e), r(V);
        }
      }
    });
    return o(V), V;
  };
}
function q(o, r) {
  return (e) => (n, i, s, V, a) => {
    const d = new B({
      node: n,
      view: i,
      getPos: s,
      decorations: V,
      innerDecorations: a,
      options: {
        ...e,
        onUpdate() {
          var u;
          (u = e.onUpdate) == null || u.call(e), d.updateContext();
        },
        selectNode() {
          var u;
          (u = e.selectNode) == null || u.call(e), d.updateContext();
        },
        deselectNode() {
          var u;
          (u = e.deselectNode) == null || u.call(e), d.updateContext();
        },
        destroy() {
          var u;
          (u = e.destroy) == null || u.call(e), r(d);
        }
      }
    });
    return o(d), d;
  };
}
function z(o, r) {
  return (e) => (n) => {
    const i = new I({
      view: n,
      options: {
        ...e,
        update: (s, V) => {
          var a;
          (a = e.update) == null || a.call(e, s, V), i.updateContext();
        },
        destroy: () => {
          var s;
          (s = e.destroy) == null || s.call(e), r(i);
        }
      }
    });
    return o(i), i;
  };
}
function G() {
  const o = A({}), r = D(), t = y({});
  return R(() => {
    t.updater = () => {
      r == null || r.update();
    };
  }), W(() => {
    t.updater = void 0;
  }), {
    portals: o,
    renderVueRenderer: (i) => {
      var s;
      o.value[i.key] = i.render(), (s = t.updater) == null || s.call(t);
    },
    removeVueRenderer: (i) => {
      delete o.value[i.key];
    }
  };
}
const b = Symbol("[ProsemirrorAdapter]widgetViewContext"), ce = () => h(b), N = Symbol("[ProsemirrorAdapter]useWidgetViewFactory"), de = () => h(N);
class J extends T {
  constructor() {
    super(...arguments);
    c(this, "key", x());
    c(this, "context", {
      view: this.view,
      getPos: this.getPos,
      spec: this.spec
    });
    c(this, "updateContext", () => {
      Object.assign(this.context, {
        view: this.view,
        getPos: this.getPos,
        spec: this.spec
      });
    });
    c(this, "render", () => {
      const t = this.component;
      return y(/* @__PURE__ */ g({
        name: "ProsemirrorWidgetView",
        setup: () => (l(b, this.context), () => w(C, {
          key: this.key,
          to: this.dom
        }, {
          default: () => [w(t, null, null)]
        }))
      }));
    });
  }
}
function Q(o, r) {
  return (e) => (n, i = {}) => {
    const s = new J({
      pos: n,
      options: e
    }), V = {
      ...i,
      destroy: (a) => {
        var d;
        (d = i.destroy) == null || d.call(i, a), r(s);
      }
    };
    return s.spec = V, H.widget(n, (a, d) => (s.bind(a, d), s.updateContext(), o(s), s.dom), V);
  };
}
const ae = /* @__PURE__ */ g({
  name: "ProsemirrorAdapterProvider",
  setup: (o, {
    slots: r
  }) => {
    const {
      portals: t,
      renderVueRenderer: e,
      removeVueRenderer: n
    } = G(), i = q(e, n), s = _(e, n), V = z(e, n), a = Q(e, n);
    return l(v, i), l(f, s), l(M, V), l(N, a), () => {
      var d;
      return w(j, null, [(d = r.default) == null ? void 0 : d.call(r), Object.values(t.value).map((u) => S(u))]);
    };
  }
});
export {
  ae as ProsemirrorAdapterProvider,
  L as VueMarkView,
  B as VueNodeView,
  I as VuePluginView,
  J as VueWidgetView,
  P as markViewContext,
  f as markViewFactoryKey,
  p as nodeViewContext,
  v as nodeViewFactoryKey,
  k as pluginViewContext,
  M as pluginViewFactoryKey,
  te as useMarkViewContext,
  re as useMarkViewFactory,
  ne as useNodeViewContext,
  oe as useNodeViewFactory,
  ie as usePluginViewContext,
  se as usePluginViewFactory,
  ce as useWidgetViewContext,
  de as useWidgetViewFactory,
  b as widgetViewContext,
  N as widgetViewFactoryKey
};
//# sourceMappingURL=index.es.js.map
